import { useLocation } from 'react-router-dom';

export const useGetPageParamsString = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const sort = searchParams.get('sort') ?? 'name';
  const page = searchParams.get('page') ?? '1';
  const pageSize = searchParams.get('pageSize') ?? '20';

  const queryString = `?sort=${sort}&page=${page}&pageSize=${pageSize}`;

  return queryString;
};
